<template>
  <div>
    <SelectServer ref="SelectServer" v-on:selectServerComplete="selectServerComplete"></SelectServer>
    <Modal
      v-model="execModal"
      :title="title"
      :mask-closable="false"
      @on-cancel="execModalCancel"
      width="1000">
      <Form ref="execForm" :model="execForm" :label-width="100">
        <Alert v-show="execForm.default_certify" show-icon>使用目标服务器绑定的第一个凭证</Alert>
        <FormItem label="用户凭证">
          <Select v-model="execForm.certificate" style="min-width:250px" :disabled="execForm.default_certify" placeholder="请选择目标服务器上存在的用户凭证">
            <Option v-for="item in allCertificateList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="默认凭证" prop="default_certify">
          <i-switch v-model="execForm.default_certify">
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
        </FormItem>
        <FormItem :label="'目标服务器(' + waitExecServerLength + ')'">
          <Button type="primary" icon="ios-desktop-outline" @click="openSelectServerModal" v-if="!waitExecServerLength">选择目标服务器</Button>
          <a v-on:click="openSelectServerModal" v-else>继续选择 </a>
          <Tag color="primary" v-for="(value, key, index) in waitExecServer" :key="'wait_hostname_' + index" v-if="value">{{ key }}</Tag>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="success" :loading="execIng" style="margin-right: 8px" icon="md-checkmark" @click="execOk">执行</Button>
        <Button @click="execModal = false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getOpsCenterAllCertificate, cronBindServerApi } from '@/api/opscenter'
import SelectServer from './select-server'

export default {
  name: 'cron-bind-modal',
  components: {
    SelectServer
  },
  data () {
    return {
      cronData: {},
      title: '脚本',
      execModal: false,
      execIng: false,
      allCertificateList: [],
      execForm: {
        default_certify: false,
        certificate: ''
      },
      waitExecServer: {},
      waitExecServerLength: 0
    }
  },
  methods: {
    // 打开执行Modal
    openModal (data) {
      this.title = '计划任务名称: ' + data.name
      this.cronData = data
      this.getAllCertificate()
      this.execModal = true
    },
    // 关闭执行Modal
    execModalCancel () {
      this.execForm.default_certify = false
      this.execForm.certificate = ''
      this.waitExecServer = {}
      this.waitExecServerLength = 0
    },
    // 获取所有凭证列表
    getAllCertificate () {
      getOpsCenterAllCertificate().then(res => {
        this.allCertificateList = res.data
      })
    },
    // 打开服务器选择Modal
    openSelectServerModal () {
      this.$refs.SelectServer.openSelectServerModal({ os: this.cronData.os }, this.waitExecServer)
    },
    selectServerComplete (server, length) {
      this.waitExecServer = server
      this.waitExecServerLength = length
    },
    execOk () {
      this.$refs['execForm'].validate((valid) => {
        if (valid) {
          let serverIds = []
          for (let i in this.waitExecServer) {
            if (this.waitExecServer[i]) {
              serverIds.push(this.waitExecServer[i])
            }
          }
          let reqData = {
            id: this.cronData.id,
            server_id: serverIds,
            certificate: this.execForm.certificate,
            default_certify: this.execForm.default_certify
          }
          this.execIng = true
          cronBindServerApi(reqData).then(res => {
            let result = res.data
            this.execIng = false
            if (result.code === 200) {
              this.execModal = false
              this.$Notice.success({
                title: '操作成功！',
                desc: result.data
              })
              this.$emit('bindOk')
            } else {
              this.$Notice.error({
                title: result.msg
              })
            }
          }).catch(res => {
            this.execIng = false
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    }
  }
}
</script>
